import { FC, useCallback, useState } from "react";

import type { TFieldsLoading, TFieldsLoadingContext } from "../../types";
import OrderFieldsLoadingContext from "../OrderFieldsLoadingContext";

const OrderFieldsLoadingProvider: FC<{ children?: any }> = ({ children }) => {
  const [fieldsLoading, setFieldsLoading] = useState<TFieldsLoading>({});

  const isFieldLoading = useCallback((fieldName: string) => !!fieldsLoading[fieldName], [fieldsLoading]);
  const setFieldLoading = useCallback(
    (fieldName: string, isLoading: boolean) => setFieldsLoading((loading) => ({ ...loading, [fieldName]: isLoading })),
    []
  );

  const value: TFieldsLoadingContext = {
    isFieldLoading,
    setFieldLoading,
  };
  return <OrderFieldsLoadingContext.Provider value={value}>{children}</OrderFieldsLoadingContext.Provider>;
};
export default OrderFieldsLoadingProvider;
